export type Vector3 = readonly [x: number, y: number, z: number];

export const PHASE_NAMES = [
  "New Moon",
  "Waxing Crescent",
  "First Quarter",
  "Waxing Gibbous",
  "Full Moon",
  "Waning Gibbous",
  "Third / Last Quarter",
  "Waning Crescent",
] as const;

export type PhaseName = (typeof PHASE_NAMES)[number];

export interface SimulationSnapshot {
  readonly lunarDay: number;
  readonly orbitalAngleRadians: number;
  readonly orbitalAngleDegrees: number;
  readonly moonPosition: Vector3;
  readonly moonToSun: Vector3;
  readonly moonToEarth: Vector3;
  readonly orbitalNormal: Vector3;
  readonly earthAxis: Vector3;
  readonly illuminatedFraction: number;
  readonly phaseAngleRadians: number;
  readonly phaseIndex: number;
  readonly phaseName: PhaseName;
  readonly isWaxing: boolean;
}
